import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { setActiveSelection } from '../actions'


const mapStateToProps = (state, ownProps) => ({
    activeSelection: state.getIn(['ui', 'settings', 'activeSelection'])
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    collapseActiveSelection: (activeClass) => {
        const activeSelectionsID = activeClass === "accordion-item-open" ? '' : ownProps.type
        dispatch(setActiveSelection(activeSelectionsID))
    }
})


const hasActiveSelection = () => WrappedComponent => {

    const HasActiveSelection = props => <WrappedComponent {...props} />

    return compose(
        connect(mapStateToProps, mapDispatchToProps)
    )(HasActiveSelection)
}

export default hasActiveSelection